import React from 'react';
import { useApi } from '../hooks/useApi';
import { useOnSyncComplete } from '../hooks/useSyncStatus';
import { api } from '../api';
import { fmtDate } from '../utils';
import {
  Card, CardHeader, Badge,
  Skeleton, PageWrap, PageHeader, Table,
} from '../components/UI';
import '../styles/SyncHistory.css';

export default function SyncHistory({ sourceId }) {
  const { data, loading, refetch } = useApi(() => api.syncHistory(sourceId), [sourceId]);
  useOnSyncComplete(() => refetch());
  const runs = data?.runs || [];

  return (
    <PageWrap>
      <PageHeader title="Sync History" sub="All data pull attempts from connected sources" />
      <Card>
        <CardHeader title={`${runs.length} Sync Runs`} />
        {loading ? <Skeleton rows={4} /> : (
          <Table
            columns={[
              { label: 'Source', key: 'source_name',
                render: r => <span className="sh-source-name">{r.source_name ?? r.name ?? '—'}</span> },
              { label: 'Period', key: 'period_from', noWrap: true,
                render: r => (
                  <span className="sh-period">{r.period_from} – {r.period_to}</span>
                )},
              { label: 'Synced At', key: 'synced_at', noWrap: true,
                render: r => <span className="sh-date">{fmtDate(r.synced_at)}</span> },
              { label: 'Vouchers', key: 'voucher_count', right: true, mono: true,
                render: r => (r.voucher_count ?? 0).toLocaleString('en-IN') },
              { label: 'Issues', key: 'issue_count', right: true, mono: true,
                render: r => (r.issue_count ?? 0).toLocaleString('en-IN') },
              { label: 'Status', key: 'status',
                render: r => (
                  <Badge
                    text={r.status}
                    variant={r.status === 'complete' ? 'green' : r.status === 'failed' ? 'red' : 'amber'}
                  />
                )},
            ]}
            rows={runs}
            emptyMsg="No sync runs found — run POST /sync first"
          />
        )}
      </Card>
    </PageWrap>
  );
}
